import { useMemo } from 'react';

export const useFormattedMobilePhone = (mobilePhone: string): string =>
  useMemo(
    // Keep phone number together.
    () =>
      `(${mobilePhone.slice(0, 3)}) ${mobilePhone.slice(
        3,
        6,
      )}-${mobilePhone.slice(6, 10)}`.replaceAll(' ', '&nbsp;'),
    [mobilePhone],
  );
